import { routerReducer } from '@ngrx/router-store';
// NGRX
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { environment } from '../../../environments/environment';
import { clearState } from '../user/_reducers/auth.reducers';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AppState {
}

export const reducers: ActionReducerMap<AppState> = {router: routerReducer};

export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [clearState]
  : [clearState];
